<template>
  <div class="wrapper" style="overflow-x: hidden;">    
   <div></div>
   <div class='title1' style="margin-top:20px">了解我们的产品</div>
   <div class='title2'>教育信息化应用工具提供商</div>
   <div v-for="(item,index) in appList" :key="index" class='app_bar'>
     <div class='app_bar_box'>
      <div></div>
      <div class="app_bar_left">
        <div style="display:flex">
          <!-- <div class='app_icon' v-if="item.name!='云学宝-教师端'"><img :src="item.icon" alt=""></div> -->
          <div class='app_icon' v-if="item.icon"><img :src="item.icon" alt=""></div>
          <div style="line-height:30px;margin-left:10px;white-space: nowrap;">{{item.name}}</div>
        </div>
        <div>{{item.content}}</div>
        <div>
          <div class='caozuo'>
            <div v-if="item.name=='云学宝-教师端'" @click="toLogin()">点击进入</div>
            <div v-if="item.name!='云学宝-教师端'"><a style="color:#fff" :href="item.appUrl" title="下载" target="_blank" >立即下载</a></div>
            <div><a style="color:#1A1A1A" :href="item.appApi" title="下载"  v-if='item.appApi' >下载软件操作手册</a></div>
          </div>
        </div>
        
      </div>
      <div class="app_bar_right">
        <img :src="item.img" alt="" style="border: 10px solid #f2f2f2;width:100%;height:740px;margin:50px 0 20px 0 ">
      </div>
      <div></div>
    </div>
    <div class='video_box'>
      <div style="width:25vw"></div>
      <div class='video_box_item'>
        <!-- <div v-for="(item_v,index_v) in data" :key='index_v' class='video_box_item_bar' v-if="item_v.category==index+1">
         <a :href="item_v.video" target="_blank" style="color:#666">
            <div style="position:relative">
              <img :src='item_v.image' alt="" style='width:150px;height:100px'>
              <div class='play_floor'>
                <img src="../assets/images/play_downPage1.png" alt="">
              </div>
            </div>
            <div style="width:150px;overflow:hidden">{{item_v.name}}</div>
         </a>
        </div> -->
        <!-- <el-carousel :interval="4000" type="card"  style="width:100%">
          <el-carousel-item v-for="(item_v,index_v) in data" :key="index_v"  v-if="item_v.category==index+1">
            <a :href="item_v.video" target="_blank" style="color:#666">
            <div style="position:relative">
              <img :src='"https://www.gaokaowin.com"+item_v.image' alt="" style='width:500px;height:270px'>
              <div class='play_floor'>
                <img src="../assets/images/play_downPage1.png" alt="">
              </div>
            </div>
            <div style="text-align:center;overflow:hidden">{{item_v.name}}</div>
         </a>
          </el-carousel-item>
        </el-carousel> -->


      </div>
      <div style="width:25vw"></div>
    </div>
    <div v-if="item.name!='WPS(pad)'" class='gray_bar'></div>
   </div>
   
  </div>
</template>

<script>

export default {
  name: "downLoad",
  data() {
    return {
      video_src:'',
      data:[],
      appList:[
     
         {
          name:'包名查看器',
          icon:'http://p.e5n.com/up/2018-3/20183199148172.png',
          content:'包名查看器是一款最新的安卓手机软件安装包apk文件包名查看的软件，可以显示在您的设备中软件安装包的包名，以及所有应用程序非常实用',
          img:'http://pic.cr173.com/up/2018-3/15214214177798582.jpg',
          appUrl:'https://www.gaokaowin.com/download/包名查看器.apk',
          appApi:''
        },
        {
          name:'学习强国',
          icon:'https://gss3.bdstatic.com/84oSdTum2Q5BphGlnYG/timg?wapp&quality=80&size=b150_150&subsize=20480&cut_x=0&cut_w=0&cut_y=0&cut_h=0&sec=1369815402&srctrace&di=b2ca58e3c8251e852f82b635487dd1b0&wh_rate=null&src=http%3A%2F%2Fimgsrc.baidu.com%2Fforum%2Fpic%2Fitem%2F2f738bd4b31c8701a5aa852b2a7f9e2f0608ffda.jpg',
          content:'学习强国》是一款学习类的app，认真的学习社会主义思想，海量的知识内容，用户在手机端就能查看学习',
          img:'http://is2-ssl.mzstatic.com/image/thumb/PurpleSource114/v4/3f/14/fe/3f14fe80-edea-a09b-99ee-7292bd8379da/7a70c6bc-7fe3-49b5-9142-d47258c88fc5_3x_iphone.png/230x0w.webp',
          appUrl:'https://www.gaokaowin.com/download/学习强国.apk',
          appApi:''
        },
        {
          name:'WPS(pad)',
          icon:'http://img1.template.cache.wps.cn/wpsweb/images/product/wps2019_animattion/logo.png?v=7-2-18-14',
          content:'简单创造不简单个性化的办公软件',
          img:'http://js1.epy.wpscdn.cn/security/hot03.jpg',
          appUrl:'https://www.gaokaowin.com/download/wps.apk',
          appApi:''
        },
        {
          name:'chrome浏览器(pc)',
          icon:'http://static.oschina.net/uploads/logo/chrome_4k6eY.png',
          content:'得益于内置的 Google 智能工具，Chrome 现在更易用、更安全、更快速。',
          img:'http://www.google.cn/chrome/static/images/benefits/module-4/connected_global_desktop.png',
          appUrl:'http://www.google.cn/chrome/',
          appApi:''
        },
        {
          name:'chrome浏览器(pad)',
          icon:'http://static.oschina.net/uploads/logo/chrome_4k6eY.png',
          content:'得益于内置的 Google 智能工具，Chrome 现在更易用、更安全、更快速。',
          img:'http://www.google.cn/chrome/static/images/benefits/module-4/connected_global_desktop.png',
          appUrl:'https://www.gaokaowin.com/download/chrome.apk',
          appApi:''
        },
        
        
        
      ]
    };
  },
   computed: {
     getDate(){
       return Date.parse(new Date());
     }
   },
  mounted() {
    // this.getVideoList()

  },
  methods: {
    toLogin(){
      this.$router.go(-1)
    },
    getVideoList(){
      this.axios
        .post("https://www.gaokaowin.com/teacher/subject/gethelpvideo").then(res => {
          // this.data=res.data.data
          // let data={pc_teacher:[],app_teacher:[],app_student:[],pc_pc:[]}
          // for(let i in res.data.data){
          //   if(res.data.data[i].category==1){
          //     data.pc_teacher.push(res.data.data[i])
          //   }
          //   if(res.data.data[i].category==2){
          //     data.app_teacher.push(res.data.data[i])
          //   }
          //   if(res.data.data[i].category==3){
          //     data.app_student.push(res.data.data[i])
          //   }
          //   if(res.data.data[i].category==4){
          //     data.pc_pc.push(res.data.data[i])
          //   }
          // }
          this.data=res.data.data
          // console.log(this.data)
        })
    },
    openVideo(data){
      // console.log(data)
       window.location.href =data.video
      // this.video_src=data.video
    }
  
  }
};
</script>
<style >
.el-carousel__item{
  height: 300px;
  width: 500px;
}
 /* .el-carousel__item h3 {
    color: #475669;
    font-size: 16px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }*/
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  } 
</style>

<style scoped >
  .title1{
    text-align: center;
    height:23px;
    font-size:24px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(26,26,26,1);
  }
  .title2{
    text-align: center;
    height:12px;
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(26,26,26,1);
  }
  .app_bar{
    min-height: 300px;
    
  }
  .app_bar_box{
    display: flex;
    justify-content: space-between;
  }
  .app_bar_box >div{
    width: 14vw;
  }
  .app_bar_box >div:nth-of-type(2){
    width: 30vw;
  }
  .app_bar_box >div:nth-of-type(3){
    width: 30vw;
  }
  .gray_bar{
    height: 24px;
    background: #F2F2F2;
    width: 100vw;
    /* margin-left: -30px; */
  }
  .app_bar_left{
    margin:50px 0 20px 0;
    
  }
  .app_bar_left>div:nth-of-type(1){
    width:232px;
    font-size:24px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(26,26,26,1);
  }
   .app_bar_left>div:nth-of-type(2){
    width:360px;
    font-size:18px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(26,26,26,1);
    margin: 30px 0 20px 0;
  }
  .caozuo{
    display: flex;
    margin: 10px 0;
  }
  .caozuo >div:nth-of-type(1){
    width:80px;
    height:30px;
    background:rgba(76,92,196,1);
    border-radius:4px;
    color: #fff;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }
  .caozuo >div:nth-of-type(2){
    height:30px;
    color: #1A1A1A;
    line-height: 30px;
    cursor: pointer;
    margin-left: 20px;
  }
  .app_icon{
    width: 30px;
    height: 30px;
  }
  .app_icon >img{
     width: 30px;
    height: 30px;
    display: block;
  }

  /* 视频 */
  .video_box{
    display: flex;
    /* height: 256px; */
    /* height: 381px; */
    margin-bottom: 20px;
  }
  .video_box_item{
    box-sizing: border-box;
    /* border: 1px solid red; */
    width: 50vw;
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
  }
  .video_box_item_bar{
    margin: 0 10px 0 0;
    text-align: center;
    cursor: pointer;
  }
  .play_floor{
    position: absolute;
    top: 0;
    right: 0;
    /* width: 150px;
    height: 100px; */
    width: 500px;
    height: 270px;
    background: #66666659;
  }
  .play_floor img{
    /* width: 50px;
    height: 50px;
    margin: 25px auto; */
    width: 80px;
    height: 80px;
    display: table-row;
    margin: 110px auto;
  }


  
</style>
